import { FootchinkoItem } from "./FootchinkoItem";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";

    export class ElasticPeg extends FootchinkoItem  {

        private scaleXFactor: number;
        private textureIdle: string;
        private textureIdleBlink: string;
        private onHitFrame: string;

        constructor(game: Phaser.Game, x: number, y: number, rightItem: boolean) {

            super(game, x, y, "" + GameVars.adversaryID, false, true, 0, rightItem);

            this.canBeHit = true;
        }

        public setBody(): void {

            // definir el cuerpo
            // un poco mas grande para complementar el tween
            this.body.setCircle(45);
            this.body.setMaterial(GameVars.getInstance().materials.elasticPegMaterial);

            this.body.static = true;
        }

        public setView(): void {

            super.setView();

            // la vista
            this.scaleXFactor = this.rightItem ? -1 : 1;

            let idle_eyes_open_frame_ID: number  = ( GameVars.adversaryID - 1) * 3 + 1;
            let idle_blink_frame_ID: number      = ( GameVars.adversaryID - 1) * 3 + 2;
            let on_hit_fame_ID: number           = ( GameVars.adversaryID - 1) * 3 + 3;

            this.textureIdle = "bumper_" +  GameVars.formatNumberForTextureAtlas(idle_eyes_open_frame_ID);
            this.textureIdleBlink = "bumper_" +  GameVars.formatNumberForTextureAtlas(idle_blink_frame_ID);
            this.onHitFrame = "bumper_" +  GameVars.formatNumberForTextureAtlas(on_hit_fame_ID);

            this.frameName = this.textureIdle;

            this.anchor.setTo(.5);

            this.name = GameConstants.ELASTIC_PEG;

            this.scale.setTo(this.scaleXFactor, 1);
        }

        public hit(): void {
            
            this.justHit = true;

            this.frameName =  this.onHitFrame;
            this.angle = Math.random() > .5 ? 10 : -10;
            this.game.time.events.add(200, this.restorePeg, this);

            let scaleX: number = Math.random() > .5 ? 1.05 : 1.15;
            let scaleY: number = Math.random() > .5 ? 1.05 : 1.15;

            this.scale.set(scaleX * this.scaleXFactor, scaleY);

            AudioManager.getInstance().playEffect("rebote_bumper");
        }
        
        // estas 2 funciones son las buenas
        public blink(): void {
            
            if (!this.game) {
                return;
            }

            if (this.justHit) {
                return;
            }

            this.frameName = this.textureIdleBlink;
            this.game.time.events.add(100, this.returnToIdle, this);
        }

        private returnToIdle(): void {

            this.frameName = this.textureIdle;
        }

        private restorePeg(): void {

            this.justHit = false;

            this.frameName = this.textureIdle;
            this.body.angle = 0;

            this.scale.setTo( this.scaleXFactor, 1 );
        }
    }
